import React from 'react'
import { useIntl } from 'react-intl'
import Modal from 'modals/dialog'
import Form from 'components/form/controller'
import StringField from 'components/form/field/string'
import Message from 'components/message'
import Status from './status'
import Actions from './actions'

const BulkRemoveDocuments = ({ act, failed, progress, dismiss, salt }) => {
    const { formatMessage } = useIntl()

    const word = formatMessage({
        id: 'action_delete',
        defaultMessage: 'Delete'
    })

    return (
        <Form
            layout="vertical"
            onSubmit={act}
            key={`${salt}:bulk:name`}>
            <Modal.Body>
                <Message
                    type="warning"
                    className="preserve-line-breaks"
                    message={formatMessage({
                        id: 'documents_bulk_remove_warning_no_confirmation',
                        defaultMessage: 'You are about to delete <strong>{count, plural, one {1 document} other {{count} documents}}<\/strong>. This action cannot be undone.'
                    }, { count: progress.total })} />
                {(progress.total > 1) && (
                    <StringField
                        salt={salt}
                        label={formatMessage({
                            id: 'label_confirm_word',
                            defaultMessage: 'Type “{word}” to confirm'
                        }, { word })}
                        name="confirmation"
                        field={{
                            required: true,
                            match: { value: word }
                        }}
                        controlProps={{ autoFocus: true }}
                        enabled={progress.processed === 0} />
                )}
                <Status
                    progress={progress}
                    failed={failed} />
            </Modal.Body>
            <Actions
                progress={progress}
                dismiss={dismiss}
                submit={{
                    label: formatMessage({
                        id: 'action_delete',
                        defaultMessage: 'Delete'
                    }),
                    destructive: true
                }} />
        </Form>
    )
}

export default BulkRemoveDocuments